import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=5491225f&scoped=true"
import script from "./DetailsSection.ts?vue&type=script&lang=ts&external"
export * from "./DetailsSection.ts?vue&type=script&lang=ts&external"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&id=5491225f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491225f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5491225f')) {
      api.createRecord('5491225f', component.options)
    } else {
      api.reload('5491225f', component.options)
    }
    module.hot.accept("./DetailsSection.vue?vue&type=template&id=5491225f&scoped=true", function () {
      api.rerender('5491225f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/DetailsSection/DetailsSection.vue"
export default component.exports